export default __webpack_public_path__ + "static/media/picture2.716a9bc4.png";